import PropTypes from "prop-types";
import Text from "components/Common/Text";
import { formatValue, matchPlayColorScheme } from "./MatchPlayCard";

export function MatchPlayTeamResultsCard({ score, active, teamName }) {
  return (
    <div
      style={{
        height: 80,
        minWidth: 84,
        backgroundColor: "white",
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: active
          ? matchPlayColorScheme(1).activeColorTeam
          : matchPlayColorScheme(1).notActiveColorTeam,
        borderRadius: 10,
        overflow: "hidden",
        marginRight: 6,
      }}
    >
      <div
        style={{
          backgroundColor: active
            ? matchPlayColorScheme(1).activeColorTeam
            : matchPlayColorScheme(1).notActiveColorTeam,
          padding: "5px",
        }}
      >
        <Text
          as="C1"
          bold
          ta="center"
          style={{
            color: active
              ? matchPlayColorScheme(1).notActiveColorTeam
              : matchPlayColorScheme(0).fontColor,
          }}
        >
          {teamName}
        </Text>
      </div>
      <Text
        ta="center"
        as="H1"
        style={{
          color: matchPlayColorScheme(score).valueFontColor,
          alignItems: "center",
          padding: 7,
        }}
      >
        {formatValue({ value: score })}
      </Text>
    </div>
  );
}

MatchPlayTeamResultsCard.propTypes = {
  active: PropTypes.bool.isRequired,
  score: PropTypes.number.isRequired,
  teamName: PropTypes.string.isRequired,
};
